const formatNumber = (phoneNumber: string) => {
  const countrycode = phoneNumber[0]
  const areacode = phoneNumber.substring(1, 4)
  const part1 = phoneNumber.substring(4, 7)
  const part2 = phoneNumber.substring(7, 11)
  return `+${countrycode} (${areacode}) ${part1}-${part2}`
}

export default formatNumber
